import React, { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { useAuth } from "../../context/AuthContext";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { AuthService } from "../../services/AuthService";
import "../../styles/header.css";
import DrawerNavbar from "./DrawerNavbar";
import { NavbarItem, NavbarTitles, getNavbarTitles } from "./NavbarItems";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";

export default function Layout(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, logoutUser } = useAuth();
  const intl = useIntl();
  const [hoverCred, setHoverCred] = useState(-1);
  const [seeMenu, setSeeMenu] = useState(false);

  const [navbarTitle, setNavbarTitle] = useState<NavbarTitles[]>([]);
  const { availableModules } = useAvailableModulesContext();

  useEffect(() => {
    const fetchNavbarTitle = async () => {
      try {
        const navbarTitles = await getNavbarTitles();

        const filteredNavbarTitles = navbarTitles.map(title => {
          if (availableModules.includes('ShowOnlyMaintenanceMenus')) {
            // Filtrar submenus específicos para os remover caso setting acima esteja ativa
            title.navbarItems = title.navbarItems.filter(item =>
              !["Navbar.Tab.Home", "Navbar.Tab.Equipments", "Navbar.Tab.Clients", "Navbar.Tab.Parts",
                "Navbar.Tab.Scheduler"
              ].includes(item.label)
            );
          }

          // Mudar o nome do menu "Assistências" para "Planos de Manutenção" caso setting ShowOnlyMaintenanceMenus esteja ativa
          if (title.name === intl.formatMessage({ id: "Navbar.Tab.Home" }) && availableModules.includes('ShowOnlyMaintenanceMenus')) {
            title.name = intl.formatMessage({ id: "Navbar.Tab.MaintenancePlans" });
          }

          // Mudar o nome do menu "Calendário" para "Manutenções" caso setting ShowOnlyMaintenanceMenus esteja ativa
          if (title.name === intl.formatMessage({ id: "Navbar.Tab.Scheduler" }) && availableModules.includes('ShowOnlyMaintenanceMenus')) {
            title.name = intl.formatMessage({ id: "Navbar.Tab.Reminder" });
          }

          return title;

        })

        setNavbarTitle(filteredNavbarTitles);
      } catch (error) {
        console.error('Erro fetching NavBar:', error);
      }
    };

    const updateSelectedNavItem = async () => {
      try {
        const navbarTitles = await getNavbarTitles();
        const pathName = location.pathname.toLowerCase();
        const selectedItem = navbarTitles.map((t: NavbarTitles) => {
          var item = t.navbarItems.find((r: NavbarItem) => r.path.toLowerCase() === pathName);
          if (item != null) return intl.formatMessage({ id: item.label });
        });
      } catch (error) {
        console.error('Erro fetching NavBar:', error);
      }
    };

    fetchNavbarTitle();
    updateSelectedNavItem();
  }, [location.pathname, availableModules]);

  const NavLink = (navbarItem: NavbarItem) => {
    if (navbarItem.IsVisible(currentUser) === false) return null;

    const samePath: boolean =
      location.pathname.toLowerCase() === navbarItem.path.toLowerCase();

    // Verificar se o nome passado está no array de módulos ativos, para ser mostrado
    const isModuleAvailable = navbarItem.moduleName
      ? Utilities.HasModule(navbarItem.moduleName, availableModules)
      : true;

    if (!isModuleAvailable) return null;

    return (
      <Link
        key={navbarItem.path}
        to={navbarItem.path}
        target={navbarItem?.newTab === true ? '_blank' : ''}
        className={`item ${samePath === true ? "selected" : ""}`}
      >
        <FormattedMessage id={navbarItem.label} />
      </Link>
    );
  };

  const logout = async () => {
    const service = new AuthService();

    var response = await service.Logout();

    if (response.success !== true) {
      Toast.Show("error", "Não foi possível fechar a sessão corretamente!");
      return;
    }

    logoutUser(currentUser!);
    navigate("/login");
  };

  return (
    <div className="parent">
      <Row className="header">
        <Col className="mobileItems" xs={6} sm={6}>
          <div style={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
            <span className="hamburguerIcon">
              <GiHamburgerMenu
                style={{
                  fontSize: "1.3rem",
                  transform: seeMenu ? "rotate(-90deg)" : "none",
                }}
                onClick={() => setSeeMenu(!seeMenu)}
              />
            </span>
            {seeMenu && <DrawerNavbar close={() => setSeeMenu(false)} />}
          </div>
        </Col>
        <Col className="items" xl={8} lg={10} md={9} sm={9} xs={6}>
          {navbarTitle.map((ni, index) => {
            if (ni.navbarItems.length === 1) {
              return NavLink(ni.navbarItems[0]);
            }
            if (Utilities.ShowParentOption(ni, currentUser, availableModules) === false)
              return null;
            return (
              <div
                key={index}
                className="drop"
                onClick={() => {
                  hoverCred === index
                    ? setHoverCred(-1)
                    : setHoverCred(index);
                }}
              >
                {ni.name}
                {hoverCred === index ? (
                  <div className="dropItems">
                    {ni.navbarItems.map((nu) => {
                      if (nu.IsVisible(currentUser)) {
                        return (
                          <React.Fragment key={nu.path}>
                            {NavLink(nu)}
                          </React.Fragment>
                        );
                      }
                      return null;
                    })}
                  </div>
                ) : (
                  ""
                )}
              </div>
            );

          })}
        </Col>

        <Col className="rightSideItems" xl={4} lg={2} md={3} sm={6} xs={6}>
          <span
            onClick={() => navigate(`/user/${currentUser?.id}`)}
            className="item"
          >
            {currentUser?.username}
          </span>
          <span onClick={logout} className="item">
            <FormattedMessage id="Navbar.Tab.Logout" />
          </span>
        </Col>
      </Row>
      <div className="body">{props.children}</div>
    </div>
  );
}
